<template>
  <base-modal ref="modal" size="5xl">
    <base-card class="tw-overlow-auto tw-relative">
      <user-business-plan-agreement
        id="printAgreement"
        :userId="userId"
        :userBusinessPlanId="plan.userBusinessPlanId"
        :planName="plan.planName"
        :priceCents="plan.priceCents"
        :currency="plan.currency"
        :termLength="plan.termLength"
        :termInterval="plan.ermInterval"
        :cycleFrequency="plan.cycleFrequency"
        :cycleInterval="plan.cycleInterval"
        :startDate="plan.startDate"
        :nextPaymentAttempt="plan.nextPaymentAttempt"
      ></user-business-plan-agreement>
      <div class="tw-flex tw-justify-end tw-gap-2">
        <base-button type="flat" @click="hide">Close</base-button>
        <base-button type="secondary" @click="printAgreement('printAgreement', plan.planName)">Print</base-button>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import UserBusinessPlanAgreement from "@/views/user/components/UserBusinessPlanAgreement";

export default {
  name: "BusinessMemberPlanAgreement",
  components: { UserBusinessPlanAgreement },
  props: {
    userId: String,
    plan: {
      type: Object,
      required: true,
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    printAgreement(agreement, planName) {
      var printContents = document.getElementById(agreement).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = planName + " Terms and Conditions" + printContents;
      window.print();
      document.body.innerHTML = originalContents;
      location.reload();
    },
  },
};
</script>
